import { render, staticRenderFns } from "./ListContact.vue?vue&type=template&id=862195fe&scoped=true"
import script from "./ListContact.vue?vue&type=script&lang=js"
export * from "./ListContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862195fe",
  null
  
)

export default component.exports